import { MENU_SECTIONS } from "./constants/sections";
export const SideMenu = {
  sections: [
    MENU_SECTIONS.SUMMARY,
    MENU_SECTIONS.TRACK,
    MENU_SECTIONS.PAYMENTS_PRODUCTS,
    // MENU_SECTIONS.LAUNCHPAD,
    MENU_SECTIONS.SEND_PAYMENTS,
    MENU_SECTIONS.BANKING,
    MENU_SECTIONS.LENDING,
    MENU_SECTIONS.SETTINGS,
    MENU_SECTIONS.DIAGNOSTIC_TOOL,
  ],
};
